interface IGetSafeSlideParams {
  slide: number;
  lastSlide: number;
}

export function getSafeSlide(params: IGetSafeSlideParams): number {
  const { slide, lastSlide } = params;

  if (slide < 0) {
    return 0;
  }

  if (slide > lastSlide) {
    return lastSlide;
  }

  return slide;
}
